<p-checkbox [inputId]="inputId" [name]="name" [value]="value" [binary]="binary" [(ngModel)]="_value" (ngModelChange)="_onValueChange($event)"  />
@if (label) {
  <label [htmlFor]="inputId" class="ml-2">{{label || ''}}</label>
}